import React, { useEffect, useState } from 'react'
import classes from "./Header.module.css";
import i18n from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../store/slices/languageSlice';

const Header = ({ hideLanguage }) => {
    const { selectedLanguage } = useSelector(state => state.languageSlice);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedLanguage && i18n.language != selectedLanguage) {
            i18n.changeLanguage(selectedLanguage);
        }
    }, [selectedLanguage, i18n]);
    return (
        <div className={classes.header}>
            {/* <img src="/assets/images/logo.png" alt="quizmaster" className={classes.logo_operator} /> */}
            {/* <img src="/assets/images/mtn.png" alt='operator' className={classes.logo_operator} /> */}

            <h1 className={classes.hutch}>HUTCH</h1>

            <img src="/assets/images/Logo_new_2.png" alt="quizmaster" className={classes.logo} />
            {/* <div className={classes.logo_language}> */}
            {
                hideLanguage ? null : (
                    <select id="lang" name="lang" className={classes.dropdown}
                        value={selectedLanguage}
                        onChange={(event) => {
                            dispatch(setLanguage(event.target.value));
                        }}
                    >
                        <option value="0">English</option>
                        <option value="1">
                            French
                        </option>
                        <option value="2">Arabic</option>
                        <option value="3">Portuguese</option>
                        <option value="4">Swahili</option>
                        <option value="5">Amharic</option>
                        <option value="6">Spanish</option>
                        <option value="7">Shona</option>
                        <option value="8">Tok Pisin</option>
                        <option value="9">Kikongo</option>
                        <option value="10">Bahasa (Indonesian)</option>
                        <option value="11">Khmer</option>
                        <option value="12">Russian</option>
                        <option value="13">Oromo</option>
                        <option value="14">Sinhala</option>
                        <option value="15">Tamil</option>
                    </select>
                )
            }

            {/* </div> */}

        </div>
    )
}

export default Header